import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import LotSenseApp from './LotSenseApp';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import AdminDashboard from './components/admin/AdminDashboard';
import UserList from './components/admin/UserList';
import UserForm from './components/admin/UserForm';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute';
import ModuleSelector from './components/ModuleSelector';
import PublicApp from './PublicApp';
import './styles/dark-mode.css';
import InvoiceTemplate from './components/InvoiceTemplate';
import ReceiptTemplate from './components/ReceiptTemplate';
import RunListPage from './components/RunListPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
        <ThemeProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/select-module" element={
            <ProtectedRoute>
              <ModuleSelector />
            </ProtectedRoute>
          } />
          <Route path="/" element={
            <ProtectedRoute>
              <LotSenseApp />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } />
          <Route path="/admin/users" element={
            <AdminRoute>
              <UserList />
            </AdminRoute>
          } />
          <Route path="/admin/users/new" element={
            <AdminRoute>
              <UserForm />
            </AdminRoute>
          } />
          <Route path="/admin/users/:id/edit" element={
            <AdminRoute>
              <UserForm />
            </AdminRoute>
          } />
          <Route path="/invoice/:dealId" element={<ProtectedRoute><InvoiceTemplate /></ProtectedRoute>} />
          <Route path="/receipt/:dealId/:paymentId" element={<ProtectedRoute><ReceiptTemplate /></ProtectedRoute>} />
          <Route path="/runlist" element={<ProtectedRoute><RunListPage /></ProtectedRoute>} />
          {/* Public routes - no auth required */}
          <Route path="/car/:stockNumber" element={<PublicApp />} />
          <Route path="/cars" element={<PublicApp />} />
        </Routes>
        </ThemeProvider>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
